import { Component, OnInit } from '@angular/core';
import { IktatgatoService } from '../iktatgato.service';

/**
 *  Iktatási statisztika: mennyi irat keletkezett, ki mennyit visz, mi csúszik.
 *  A lejárt határidők oszlopa a lényeg – az összesítés csak addig érdekes, amíg
 *  meg is mutatja, hol áll meg az ügymenet.
 */
@Component({
  selector: 'app-ikt-riport',
  templateUrl: './riport.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktRiportComponent implements OnInit {
  ev = new Date().getFullYear();
  adat: any = null;
  betoltes = false;

  readonly HONAPOK = ['jan', 'feb', 'már', 'ápr', 'máj', 'jún', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'];

  constructor(private ikt: IktatgatoService) {}

  async ngOnInit() { await this.betolt(); }

  async betolt() {
    this.betoltes = true;
    try { this.adat = await this.ikt.riport(this.ev); }
    catch { this.adat = null; }
    finally { this.betoltes = false; }
  }

  honapNev(h: number) { return this.HONAPOK[h - 1] || String(h); }

  /** A havi oszlopdiagram magassága a legnagyobb hónaphoz viszonyítva. */
  oszlopMagassag(db: number) {
    const max = Math.max(1, ...(this.adat?.havonta || []).map((h: any) => Number(h.db) || 0));
    return Math.round((Number(db) || 0) / max * 100);
  }
}
